import React, { useState, useEffect } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { BsSearch } from "react-icons/bs";
import { FiDownload } from "react-icons/fi";
import { MdOutlineTune } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";
import { IoSearch } from "react-icons/io5";

const SearchComponent = ({
  placeholder,
  onSearch,
}: {
  placeholder: string;
  onSearch?: (searchTerm: string) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );

  // Debounce the search to avoid too many API calls
  const debouncedSearch = debounce((term: string) => {
    if (onSearch) {
      onSearch(term);
    }
    // Update URL params
    if (term) {
      setSearchParams({ search: term });
    } else {
      searchParams.delete("search");
      setSearchParams(searchParams);
    }
  }, 500);

  // Handle input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  // Initialize search from URL params on component mount
  useEffect(() => {
    const searchFromUrl = searchParams.get("search");
    if (searchFromUrl && onSearch) {
      setSearchTerm(searchFromUrl);
      onSearch(searchFromUrl);
    }
  }, []);

  return (
    <div>
      <header className="py-1 flex items-center w-full gap-5">
        <div className="flex items-center justify-between gap-4 py-4  relative w-full">
          {/* <BsSearch fill="#505153" size={12} /> */}
          <input
            type="text"
            placeholder={placeholder}
            className="h-12 w-full  focus:outline-none active:outline-none rounded-md px-2 pl-8 placeholder:text-sm bg-[#E5F2EA]"
            value={searchTerm}
            onChange={handleSearchChange}
          />

          <div className="absolute text-[#0EB683] left-[14px] ">
            <IoSearch />
          </div>
        </div>
      </header>
    </div>
  );
};

export default SearchComponent;
